import React from "react";
import { FaLinkedin, FaGithub, FaHome, FaUserCircle } from "react-icons/fa";
import { ImProfile } from "react-icons/im";
import { BsCode } from "react-icons/bs";
import { MdContactPage } from "react-icons/md";

// data.js
export const navLinks = [
  { id: 1, url: "#hero", text: "Home", icon: "bi-house-door" },
  { id: 2, url: "#about", text: "About", icon: "bi-person" },
  { id: 3, url: "#skills", text: "Skills", icon: "bi-person" },
  { id: 4, url: "#resume", text: "Resume", icon: "bi-briefcase" },
  { id: 5, url: "#portfolio", text: "Portfolio", icon: "bi-briefcase" },
  { id: 6, url: "#contact", text: "Contact", icon: "bi-envelope" },
];

export const socialLinks = [
  { id: 1, url: "https://www.linkedin.com", icon: "bi-linkedin", title: "LinkedIn" },
  { id: 2, url: "https://github.com", icon: "bi-github", title: "GitHub" },
];

export const about = [
  { id: 1, title: "Phone", value: "04 2068 4569" },
  { id: 2, title: "City", value: "Melbourne, Australia" },
  { id: 3, title: "Birthdate", value: "September 30, 1996" },
  { id: 4, title: "Email", value: "ashmin.karki1996@gmail.com" },
];

export const aboutShort = [
  {
    text: "I am a versatile Web Developer with 2+ years of experience in front-end and back-end development, specializing in PHP (CodeIgniter), WordPress, and ReactJS.",
  },
];
export const aboutLong = [
  {
    text: "",
  },
];
export const skills = [
  {
    category: "Frontend",
    items: [
      { id: 1, name: "HTML", level: 100 },
      { id: 2, name: "CSS", level: 100 },
      { id: 3, name: "JavaScript", level: 80 },
      { id: 4, name: "ReactJS", level: 70 },
    ],
  },
  {
    category: "Backend",
    items: [
      { id: 1, name: "NodeJS", level: 85 },
      { id: 2, name: "PHP", level: 90 },
      { id: 3, name: "MySQL", level: 80 },
      { id: 4, name: "MongoDB", level: 80 },
    ],
  },
  {
    category: "Tools & Frameworks",
    items: [
      { id: 1, name: "Git", level: 90 },
      { id: 2, name: "Docker", level: 50 },
      { id: 3, name: "AWS", level: 50 },
    ],
  },
];

export const resumeEducation = [
  {
    title: "MASTER OF INFORMATION TECHNOLOGY",
    timeline: "2022-2024",
    place: "Swinburne University of Technology",
    description: "Focus on Web Application Development, Intelligent Chatbot System, and Full-Stack Projects.",
  },
  {
    title: "BACHELOR'S IN COMPUTER SCIENCE & INFORMATION TECHNOLOGY",
    timeline: "2015-2019",
    place: "Tribhuwan University, Nepal",
    description: "Graduated with First Division (78.40%), specializing in Computer Science concepts. Final Year Project: 'Hostel Recommendation System Using User-Based Collaborative Filtering.'",
  },
  {
    title: "+2",
    timeline: "2012-2014",
    place: "St. Xavier's College, Kathmandu, Nepal",
    description: "Passed Plus Two with Distinction in Science.",
  },
];

export const resumeProfessionalExperience = [
  {
    title: "MID-LEVEL WEB DEVELOPER",
    timeline: "February 2021 - July 2022",
    company: "Qubygroup, Bahrain",
    skills: [
      "Developed fully functional e-commerce websites using WordPress.",
      "Designed custom templates and integrated Pods backend.",
      "Built referral and lottery systems using the CodeIgniter framework.",
      "Contributed to the development of the Jareed Hotels website, ensuring optimal performance.",
    ],
  },
  {
    title: "JUNIOR WEB DEVELOPER",
    timeline: "December 2019 - August 2020",
    company: "Bonjour Management Pvt. Ltd, Nepal",
    skills: [
      "Supported senior developers in enhancing in-house systems.",
      "Created an employee attendance and management system.",
      "Integrated JavaScript plugins and conducted system testing and debugging.",
    ],
  },
  {
    title: "WEB DEVELOPMENT INTERN",
    timeline: "September 2019 - November 2019",
    company: "Bonjour Management Pvt. Ltd, Nepal",
    skills: [
      "Developed a CMS website using Laravel framework.",
      "Tested and debugged systems under development.",
    ],
  },
];

export const portfolio = [
  {
    id: 1,
    title: "A Million Palms",
    category: "WordPress",
    url: "https://amillionpalms.com/",
    image: "assets/img/portfolio/project1.jpg",
  },
  {
    id: 2,
    title: "Kind and Klean",
    category: "WordPress",
    url: "https://kindandklean.com/",
    image: "assets/img/portfolio/project2.png",
  },
  {
    id: 3,
    title: "Bus Ko Ticket",
    category: "CodeIgniter",
    url: "https://buskoticket.com/",
    image: "assets/img/portfolio/project7.jpg",
  },
  {
    id: 4,
    title: "React Calculator",
    category: "Personal",
    url: "https://ashminkarki.com.np/react-calculator/",
    image: "assets/img/portfolio/project8.jpg",
  },
  {
    id: 5,
    title: "Jareed Hotels",
    category: "WordPress",
    url: "https://jareedhotels.com",
    image: "assets/img/portfolio/project10.png",
  },
];
